"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AgsAssessmentSerializer = void 0;
var models_1 = require("../../models");
var constants_1 = require("../../constants");
/**
 * Serializes assessment
 *
 * @author javier.perez
 */
var AgsAssessmentSerializer = /** @class */ (function () {
    function AgsAssessmentSerializer() {
    }
    AgsAssessmentSerializer.prototype.serialize = function (_a) {
        var id = _a.id, contextId = _a.contextId, title = _a.title, curriculum = _a.curriculum, status = _a.status, startDate = _a.startDate, assignedDate = _a.assignedDate, avgScore = _a.avgScore, maxScore = _a.maxScore, createdAt = _a.createdAt, createdBy = _a.createdBy, updatedAt = _a.updatedAt, updatedBy = _a.updatedBy;
        return new models_1.AgsAssessment({
            id: id,
            contextId: contextId,
            title: title,
            curriculum: curriculum,
            status: status ? (0, constants_1.getAssessmentStatusFrom)(status) : undefined,
            startDate: startDate,
            assignedDate: assignedDate,
            avgScore: avgScore,
            maxScore: maxScore,
            createdAt: createdAt,
            createdBy: createdBy,
            updatedAt: updatedAt,
            updatedBy: updatedBy,
        });
    };
    return AgsAssessmentSerializer;
}());
exports.AgsAssessmentSerializer = AgsAssessmentSerializer;
